// Modules
import React from 'react'

// Routes
import Routes from './routes/Main'

// Components
import Page from 'components/layout/page/Page'

// Hooks
// import useLanguage from 'hooks/system/useLanguage'

// Styles
import './Reset.scss'

// Page: Reset
function Reset () {
	// Data
	// const { translate } = useLanguage('pages.reset')

	// Render
	return (
		<Page
			isPublic
			name="reset">
			<Routes />
		</Page>
	)
}

// Export
export default Reset
